import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "../tooltips";

interface IHubRideCompanionMarkProps {
  className?: string;
}

export const HubRideCompanionMark: FC<IHubRideCompanionMarkProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const label = t("ride.HUB_RIDE_COMPANION");

  return (
    <FramerTooltip content={label}>
      <span className={className} aria-label={label}>
        ⚭
      </span>
    </FramerTooltip>
  );
};
